<template>
  <div class="jbxx">
    <div class="jbxx-handle">
      <el-button type="primary"  v-if="!isEdit" @click="isEdit=true" icon="el-icon-edit" size="mini">进入编辑</el-button>
      <el-button type="primary" v-if="isEdit" icon="el-icon-check" size="mini" @click="handleConfirm" :loading="loadBtn">点击提交</el-button>
    </div>
    <el-form
      inline
      ref="form"
      class="search-form"
      label-position="right"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="项目名称：" class="input-with-col4" prop="projectName">
        <el-input
          size="mini"
          v-model.trim="form.projectName"
          placeholder="请输入项目名称"
          :disabled="!isEdit"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人：" class="input-with-col4">
        <el-input
          size="mini"
          v-number-only:11
          :disabled="!isEdit"
          v-model.trim="form.contacts"
          placeholder="请输入联系人"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" class="input-with-col4">
        <el-input
          size="mini"
          v-number-only:11
          :disabled="!isEdit"
          v-model.trim="form.contactTelephone"
          placeholder="请输入联系电话"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话2：" class="input-with-col4">
        <el-input
          size="mini"
          v-number-only:11
          :disabled="!isEdit"
          v-model.trim="form.contactTelephone2"
          placeholder="请输入联系电话2"
          clearable
        ></el-input>
      </el-form-item>
      <AddreassSelect
        :disabled="!isEdit"
        :warning="addressWarn"
        :initData="defaultAddress"
        class="input-with-col4 mr0"
        @change="setPojectAddress"
      ></AddreassSelect>
    <el-form-item label="使用单位：" prop="propertyUnitName"  class="input-with-col4">
           <el-input size="mini" v-model.trim="form.propertyUnitName" placeholder="请输入使用单位" clearable></el-input>
        </el-form-item>
<!--      <el-form-item label="使用单位：" prop="propertyUnitId" class="input-with-col4">
        <el-input
          size="mini"
          v-number-only:11
          :disabled="!isEdit"
          v-model.trim="form.propertyUnitName"
          placeholder="请输入使用单位"
          clearable
        ></el-input>
        </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import {
  addProject,
  getDepartmentList,
  getUnitSimpleList,
} from "@/api/ProjectManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import { getDetail } from "@/api/salesManagement/detail";
export default {
  name: "ProjectJBXX",
  data() {
    return {
      form: {
        contactTelephone: "",
        contactTelephone2: "",
        contacts: "",
        address: "",
        cityCode: "",
        projectName: "",
        districtCode: "",
        provinceCode: "",
        propertyUnitName: "",
        // departmentIdList: [],
      },
      isEdit: false,
      addressWarn: false,
      rules: {
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        departmentIdList: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      unitList: [],
      departmentList: [],
      propertyObj: {},
      departmentObj: {},
      defaultAddress: {},
    };
  },
  components: {
    AddreassSelect,
  },
  props: ["projectId"],

  created() {
    // this.searchUnitList();
    this.searchDepartmentList();
    this.getProjectDetail();
  },
  methods: {
    async getProjectDetail() {
      const res = await getDetail(this.projectId);
      if (res.code === 200) {
        this.form = { ...res.data };
        // this.propertyObj = {
        //   id: res.data.propertyUnitId,
        // };
        let arr = [];
        if (res.data.departmentInfo && res.data.departmentInfo.length) {
          arr = res.data.departmentInfo.map((item) => item.departmentId);
        } else {
          arr = [];
        }
        this.$set(this.form, "departmentIdList", arr);
        this.$nextTick(() => {
          this.defaultAddress = {
            addressData: this.form.address,
            provinceCode: this.form.provinceCode,
            provinceName: this.form.provinceName,
            cityCode: this.form.cityCode,
            cityName: this.form.cityName,
            townCode: this.form.districtCode,
            townName: this.form.districtName,
          };
        });
      }
    },
    async searchDepartmentList(keyword) {
      const res = await getDepartmentList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await addProject(this.form);
          if (res.code === 200) {
            this.$message.success("编辑成功");

          }
          this.loadBtn = false;
          this.isEdit = false;
        }
      });
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
    chooseProperty(data) {
      if (data && data.id) {
        this.form.propertyUnitId = data.id;
        this.form.propertyUnitName = data.unitName;
      } else {
        this.form.propertyUnitId = "";
        this.form.propertyUnitName = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.jbxx {
  &-handle {
    margin-bottom: 16px;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/jbxx.vue